// import "./pouchDB.js";
// import { dateShifter } from './ktt-controller'

import "./dev/dev-helpers";
import "./dev/dev-display-versions";

import { tippyHandler, editEntryModalTooltip } from "./dependencies/tippy.js";
import "./dependencies/eruda.js";
import "iconify-icon";
import "./shared/ktt-global.js";
import "./ktt-window.js";
import "./ktt-document.js";

import "./shared/ktt-components.js";
import { html, css } from "./utils/template-literal-tags.js";
import { API_BASE } from "./shared/ktt-host.js";
import * as data from "./log/ktt-data.js";
import { getTagObj } from "./log/tags/class-tag.js";
import * as rhythm from "./features/rhythm/rhythm";
import * as url from "./utils/url";
import * as tags from "./log/tags/tags.js";
import * as dom from "./utils/dom";
import * as time from "./utils/time";
import * as table from "./utils/ktt-tables.js";
import * as svg from "./utils/ktt-svg.js";
import * as print from "./ktt-html.js";
import { getDatabase } from "./log/build-log.js";
import { makeRequest } from "./ktt-requests.js";
import { filterRhythmTags } from "./log/ktt-data.js";

console.log("DEVMODE: ", import.meta.env.MODE);
console.log("API_BASE: ", API_BASE);

// ========= Variables ========= ========= =========

function clearSummary() {
  window.HTML.summaryMain.innerHTML = ""; // clear it each time
  window.HTML.summaryStats.innerHTML = ""; // clear it each time
  document.getElementById("areas").innerHTML = "";
}

window.ktt = {
  rhythm: () => ({
    entry: {
      rhythm: {
        mood: document.getElementById("rhythm-mood").dataset.value,
        energy: document.getElementById("rhythm-energy").dataset.value,
        clarity: document.getElementById("rhythm-clarity").dataset.value,
      },
      startTime: time.timestamp(),
    },
  }),
  entry: () => ({
    startTime: time.timestamp(),
    comment: document.querySelector("#post input").value,
    tags: document.querySelector("#post select").value,
  }),
  newOngoingEntry: (event) => {
    const entry = JSON.parse(event.detail.parameters.entry);

    if (document.querySelector(`entry-ongoing[data-tag="${entry.tags}"]`)) {
      return;
    }

    const ongoingEntries = document.getElementById("ongoing-entries");
    const ongoingWidget = document.createElement("entry-ongoing");
    ongoingWidget.entry = entry;
    ongoingEntries.appendChild(ongoingWidget);
  },
};

// UI Bindings
window.displayTagOverlay = displayTagOverlay;
window.toggleClass = dom.toggleClass;
window.toggleClassAll = dom.toggleClassAll;

// Start
// ========= ========= ========= =========
async function start() {
  console.log(
    `%c %--[=========> %c start() ${performance.now()}ms %c`,
    "color: orange",
    "color: white",
    "color: orange",
  );

  async function setup() {
    console.info("setup()");
    window.logFile = await getDatabase();
    if (window.logFile) {
      console.info("displayLog()");
      displayLog();
    }
  }

  // display loading;
  try {
    await setup();
  } catch (error) {
    console.warn("KTT init: getDatabase()", error);

    const button = document.createElement("button");
    button.innerText = "Retry";
    button.addEventListener("click", async () => await start());

    const login = document.createElement("div");
    login.id = "login-form";
    login.innerHTML = html`
      <form action="${API_BASE}/login" method="post" id="login">
        Login
        <input name="username" id="user" type="text" placeholder="user" />
        <input name="password" id="password" type="password" placeholder="password" />
        <input type="submit" value="Submit" />
      </form>
    `;

    notices.innerHTML = "Couldnt load - ";
    notices.append(button);
    notices.append(login);

    const loginForm = document.getElementById("login");
    loginForm.addEventListener("submit", (event) => {
      event.preventDefault();
      const formData = new FormData(loginForm);
      console.log("loginForm", loginForm);
      for (const [key, value] of formData.entries()) {
        console.log(key, value);
      }

      fetch(API_BASE + "/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData),
        credentials: "include",
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            start();
          }
        })
        .catch((error) => console.log("error", error));
    });
  }
}

window.start = async () => await start();

start();

document.addEventListener("DOMContentLoaded", () => {
  const newEntry = document.getElementById("new-entry");
  newEntry?.addEventListener("click", async () => {
    const entry = window.ktt.entry();
    await makeRequest({
      endpoint: "/entries/new-entry",
      method: "POST",
      body: { entry: { ...entry } },
    });

    if (document.querySelector(`entry-ongoing[data-tag="${entry.tags}"]`)) {
      return;
    }

    const ongoingEntries = document.getElementById("ongoing-entries");
    const ongoingWidget = document.createElement("entry-ongoing");
    ongoingWidget.entry = entry;
    ongoingEntries.appendChild(ongoingWidget);

    window.start();
  });

  const logoutButton = document.getElementById("logout-button");
  logoutButton?.addEventListener("click", async () => {
    console.log("clear");
    await makeRequest({
      endpoint: "/user/logout",
      method: "POST",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          window.location.href = "/";
          console.warn("BOOP!");
        }
      })
      .catch((error) => console.log("error", error));
  });
});

// End
// ========= ========= ========= =========

// Function Definitions

// View
// ======================================================
function displayLog(queryDates = queryLog(dateShifter())) {
  // displayDashboard();

  displayMainGraph(queryDates);

  displayMoodGraph(Object.entries(queryDates));

  displaySummary(queryDates);

  displayYearSummary();

  // displayMoodComments(queryDates)

  displayCurrentAnchorOverlay();

  loadOngoingEntries();

  notices.innerHTML = "";

  console.log(`%c <=========]--% %c - * - %c %--[=========> \n \n \n `, "color: cyan", "color: white", "color: cyan");
}

function loadOngoingEntries() {
  const ongoingEntries = document.getElementById("ongoing-entries");
  ongoingEntries.innerHTML = "";

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith("KTT-ongoing-")) {
      const ongoingLS = localStorage.getItem(key);
      const entry = JSON.parse(ongoingLS);
      const entryOngoingWidget = document.createElement("entry-ongoing");
      entryOngoingWidget.entry = entry;
      ongoingEntries.appendChild(entryOngoingWidget);
    }
  }
}

async function displayCurrentAnchorOverlay() {
  const currentAnchor = url.getCurrentAnchor();

  if (currentAnchor) {
    const tagObj = await getTagObj(currentAnchor[0].replace("#", ""));
    if (tagObj) {
      displayTagOverlay(tagObj);
    }
  }
}

function displayDashboard() {
  document.getElementById("dashboard").innerHTML = `
    ${print.HTMLDashboardBox(displayDashboardRhythm())}
    ${print.HTMLDashboardBox(displayDayForesight())}
    ${print.HTMLDashboardBox(displayDashboardGoals())}
  `;
}

// Dashboard Goals
function displayDashboardGoals(_dates, _tags) {
  return {
    name: "goals",
    content: `
      <h3><a href="${window.config.urls.Goals}">Streak Building</a></h3>
      <div class="entries">
        ${Object.values(window.fm.goals)
          .map((goal) => {
            if (goal.isGoalActive()) {
              return print.goalbox(goal, "#dashboard-goals .entries");
            }
          })
          .join("")}
      </div>`,
  };
}

// Dashboard Rhythm
function displayDashboardRhythm() {
  if (Object.entries(window.viewQuery.query)[0][1].length == 0) return undefined;

  // remove dashboard on non-single-day query
  if (document.querySelector("body").getAttribute("timespan") == "day") {
    // [] make a new function that makes a rhythm entry inside each Entry that stores this data
    return {
      name: "rhythm",
      content: `
        <h3>Rhythm</h3>
        ${print.HTMLDataSleep()}
        ${print.HTMLMoodFlow()}
        ${print.HTMLDataFood()}
      `,
    };
  } else {
    return "";
  }
  // display time-awake
  // display average mood, energy, clarity for this period
}

function displayDayForesight() {
  // let rhythm_assist_data = {'goal1': '21:20', 'goal2': '22:30', 'goal-number3': '23:45'} //get_rhythm_assist_data();
  // let HTML_rhythm_assist_data = generateHTMLListFromJSON( rhythm_assist_data, 'ul')

  const { timeLeft, finishTime, finishTimeBuffer } = data.calculateDayForesight();

  return {
    name: "day-foresight",
    content: `
      <h3>Day Foresight</h3>
      <ul class="data-foresight">
        <li><label>Goal practice left:</label> ${timeLeft}</li>
        <li><label>Finish time:</label>
          ${finishTime} ~ ${finishTimeBuffer}
        </li>
      </ul>
    `,
  };
}

function closeOverlay(tagName) {
  removeElement(".screen-dim");

  if (tagName) {
    removeElement(`tagdata-${tagName}`);
  } else {
    document.querySelector(`.overlay`)?.remove();
  }

  if (url.getCurrentAnchor()) {
    // history.pushState(null, '', window.location.pathname + window.location.search);
    window.location.hash = "";
  }
}

// make summaryofhabitdata should just make the summary of the data, and save the keys to the habit obj...
// then another function parses that into the HTML keys list
// and another function parses it into the data array summary list

// make summaryofhabit data: to be called at the beginning, by the log
// and saves its key data into the log
//
// then later the goalObj calls it and makes the 2 html thigns out of it:
//  the keys HTML list
//  the summary dataArray HTML list

/**
 * [displayTagOverlay description:
 *
 * Displays an overlay window that shows two things:
 * 1. streakdata corresponding to this tag, by calling
 *    displayStreakPill() for each goal that has this tag
 * 2. tag data from tagData() function, which shows summaries
 *    aggregated from all the entries that have that tag, since the start
 *    of the log]
 *
 * @param  {[string]} tag_or_goalID [string that is either a tag or a goalID.]
 * @return {[void]}
 */
async function displayTagOverlay(tag) {
  const tagObj = await getTagObj(tag);

  displayScreenDim(tagObj.name);

  const goals = data.getGoalIDsFromTag(tagObj);

  // Make `thisMonthGoals` and `otherGoals` arrays
  const { thisMonthGoals, otherGoals } = goals.reduce(
    (result, goal) => {
      const conditionMet = time.isCurrentDate(goal.date_end, "month");

      if (conditionMet) {
        result.thisMonthGoals.push(goal);
      } else {
        result.otherGoals.push(goal);
      }

      return result;
    },
    { thisMonthGoals: [], otherGoals: [] },
  );

  window.closeOverlay = closeOverlay;
  // console.log('overlay: ', tagObj)
  document.getElementById(`overlays`).innerHTML = `
    <div class="overlay" id="tagdata-${tagObj.name}">
      <div id='overlay-container'>

        <button aria-label='Close Overlay' class="close" onclick="closeOverlay('${tagObj.name}')">⨯</button>

        <h3>${tagObj.name.toUpperCase()}</h3>
        ${print.tagData(tagObj)}

        <div class='overlay-block'>
          <h4>Total Data</h4>
          ${svg.HTML_SVG_Graph(tagObj)}
        </div>

        <div class='overlay-block'>
          <h4>Active Goal</h4>
          ${print.streakListings(thisMonthGoals, true)}
        </div>

        <div class='overlay-block'>
          <h4>Total Entries History</h4>

          <button class="toggle" onclick="toggleClass('entries_history', 'collapsed')"  >History Table</button>
          <div id="entries_history" class="collapsible">
            ${table.HTML_EntriesTable(tagObj)}
          </div>
        </div>

        <div class='overlay-block'>
          <h4>Past Goals</h4>
          ${print.streakListings(otherGoals, true, "small")}
        </div>
      </div>
    </div>
  `;
}

// UI
function removeElement(element) {
  // Remove based on ID
  if (document.getElementById(element)) {
    document.getElementById(element).remove();

    // Remove based on class
  } else if (document.querySelector(`${element}`)) {
    document.querySelector(`${element}`).remove();
  }
}

function displayScreenDim(tagName) {
  document.querySelector("body").insertAdjacentHTML(
    "afterbegin",
    `
    <div
      class="screen-dim"
      onclick="closeOverlay('${tagName}')">
    </div>
  `,
  );
  closeableWindow(`tagdata-${tagName}`);
}

function closeableWindow(element, key = "Escape") {
  window.addEventListener("keyup", (event) => {
    if (event.key == key) {
      closeOverlay();
    }
  });
}

// ========= Queries ========= ========= ========= ========= ========= ========= ========= =========

function queryLog(dates, obj, _tags) {
  // if given an array of tags, filter it to hide any tags that aren't in the array
  dates = dates || [window.viewQuery.today];

  // if we get a single date object, put it in an array
  if (dates instanceof Date) {
    dates = [dates];
  }

  // strip all dates of their time signatures
  dates = dates.map((date) => {
    return time.dateNoTime(date);
  });

  window.viewQuery.query = {}; // clear the last query every time

  // make array of entries based on the received dates
  for (let x = 0; x < dates.length; x++) {
    if (Object.entries(window.logFile.fullLogNoTime).indexOf(dates[x]) != undefined) {
      // check that the day exists
      if (window.logFile.fullLogNoTime[dates[x]] != undefined) {
        window.viewQuery.query[dates[x]] = window.logFile.fullLogNoTime[dates[x]];
      } else {
        window.viewQuery.query[dates[x]] = [];
        console.warn("window.viewQuery.query is empty!");
      }
    }
  }

  // console.info('❓ window.viewQuery.query: ', Object.entries(window.viewQuery.query));
  // console.info('❓ window.viewQuery.query habits: ', Object.entries(window.viewQuery.query)[0][1].habits);

  makeQuerySummary(Object.entries(window.viewQuery.query));

  // add a simple syntax to access the list of dates in the query
  window.viewQuery.queryDates = Object.keys(window.viewQuery.query);

  window.viewQuery.queryDateFirst = time.dateNoTime(window.viewQuery.queryDates[0]) || window.viewQuery.queryDates;
  window.viewQuery.queryDateLast =
    time.dateNoTime(window.viewQuery.queryDates[window.viewQuery.queryDates.length - 1]) || window.viewQuery.queryDates;

  // simple syntax to more easily get the dateObj out of the current query
  window.viewQuery.queryObj = Object.values(window.viewQuery.query)[0];

  if (obj) {
    return Object.entries(window.viewQuery.query)[0][1];
  } else {
    return window.viewQuery.query;
  }
}

// ========= HTML Graph ========= ========= ========= ========= ========= ========= ========= =========

function displayMainGraph(queryDates = queryLog()) {
  let dates = Object.keys(queryDates);

  clearGraph();

  printGraphTimeBar();

  displayQueryDate(dates); // display Main date

  // Display each Day
  for (let day = 0; day < dates.length; day++) {
    if (queryDates[dates[day]] == undefined) {
      return;
    } // exit if no entries on this date

    document.getElementById("graph-entries").insertAdjacentHTML("beforeend", `<ul id="u${day}"></ul>`);

    // loop through each Entry
    for (let entryNum = 0; entryNum < queryDates[dates[day]].entries.length; entryNum++) {
      printHTMLGraphEntry(queryDates, day, entryNum); // prints the <li>
      // printHTMLMoodComments(queryDates, day, entryNum)
    }
  }

  // Print out the #graph-date dates.
  if (time.getQueryTimeSpan() != "year") {
    for (let day = 0; day < dates.length; day++) {
      if (queryDates[dates[day]] == undefined) {
        return;
      } // exit if no entries on this date

      const daynum = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
      }).format(new Date(dates[day]));
      const weekday = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(new Date(dates[day]));
      document.getElementById(`graph-date`).insertAdjacentHTML(
        "beforeend",
        `
        <span class="date-group">
          <span class="weekday">${daynum}</span>
          <span class="date">${weekday}</span>
        </span>
        `,
      );
    }
  } else if (time.getQueryTimeSpan() == "year") {
    for (let month = 0; month < 12; month++) {
      document.getElementById(`graph-date`).insertAdjacentHTML(
        "beforeend",
        `
        <span class="date-group">
          <spann class="month">${ui.monthNamesShort[month]}</span>
        </span>`,
      );
    }
  }

  if (time.getQueryTimeSpan() == "day") {
    // Print out future-day schedule
    printFutureSchedule();
  }
}

function printFutureSchedule() {
  // Get goals
  const activeGoals = Object.values(window.fm.goals).filter((goal) => goal.isGoalActive() && goal.isInPeriod());
  console.log("activeGoals: ", activeGoals);

  // need to get the current time... and start printing from there onward
  // need to refactor printHTMLGraphEntry so that you can print out an item just by passing in its duration and its name etc.

  // first ones start time is now. next one is the end of the prior one.

  let priorEnd = undefined;

  activeGoals.forEach((goal) => {
    console.log("goal:", goal, goal.tag);

    // [] create a "goal.targetRemainingThisPeriod()"
    let duration = goal.totalPracticedThisPeriod()
      ? goal.getTargetForThisPeriod() - goal.totalPracticedThisPeriod()
      : goal.getTargetForThisPeriod();

    let entryData = {
      entryStartPosY: undefined,
      entryStartPosX: undefined,
      entryHeight: 16,
      entryWidth: undefined,
      entryLine: "",
      tagList: goal.tag,
      spanEntryStart: "",
      spanEntryEnd: "",
      tagSpan: undefined,
      spanDuration: undefined,
      spanEntryComment: undefined,
      entry: {
        start: priorEnd ? priorEnd : time.dateToHHMM(new Date()), // HH:MM
        end: undefined, // HH:MM
        duration: duration,
        comment: goal.description,
      },
      day: 0,
      type: "tag future",
    };

    let dateObj = time.hhmmStringToJS(entryData.entry.start);
    entryData.entry.end = time.dateToHHMM(time.addMins(dateObj, entryData.entry.duration));

    entryData = formatEntryPillElements(entryData);
    entryData = calculateEntryPillDimensions(entryData);
    entryData.tagSpan = `<span class="tag-label">${goal.tag}</span>`;
    entryData.spanEntryStart = `<span class="entry-start">${entryData.entry.start}</span>`;

    printEntryPill2(entryData);
    // printEntryPillExtended(entryData)

    priorEnd = entryData.entry.end;
  });
}

function printGraphTimeBar() {
  //print out each hour of the day
  let hour = ui.dayStartTime;
  for (let i = 1; i <= ui.dayLength; i++) {
    if (hour >= 24) {
      hour = hour - 24;
    } // wrap a 24h clock to restart at 0
    hour = String(hour).padStart(2, "0");

    // print it into an html list item
    document.querySelector("#graph-timebar > ul").insertAdjacentHTML("beforeend", `<li>${hour}</li>`);
    hour++;
  }
}

function _displayMoodComments(queryDates = queryLog()) {
  // Group them by mood number
  // Print the high, low and avg mood# of the period

  // runs once
  // goes through each day
  // grabs the mood comment
  // puts it into a big list
  // sorts the list
  // prints out the list
  // printHTMLMoodComments(queryDates)
  //

  let dates = Object.keys(queryDates);
  for (let day = 0; day < dates.length; day++) {
    // console.log(day)
    if (queryDates[dates[day]] == undefined) {
      return;
    } // exit if no entries on this date

    // console.log(queryDates)
    for (let entryNum = 0; entryNum < queryDates[dates[day]].entries.length; entryNum++) {
      let entry = queryDates[dates[day]].entries[entryNum];
      // console.log(entry);

      let moodComment = [];

      // if the entry has a comment or a mood tag
      if (entry.comment != " " || window.fm.mood.some((r) => entry.tags.includes(r))) {
        let _comment = data.parseComments(entry.comment);
        let moodTag, otherTags, _moodBlock;

        entry.tags.forEach((tag) => {
          moodTag = makeMoodTag(entry, tag);
          if (moodTag != undefined) {
            _moodBlock = `<span class="moodBlock" id="${moodTag[0]}">${moodTag[1]}</span>`;
          } else {
            moodBlock = "";
          }

          otherTags = entry.tags.filter((tag) => !window.fm.mood.includes(tag));
          if (otherTags.length != 0) {
            otherTags = `<span class="tag ${otherTags}">${otherTags}</span>`;
          }
        });
        moodComment.push(moodTag);
        moodComment.push(entry.comment);
      }
      // console.log(moodComment)

      // here, add the entry printout into an array so i can sort them from m10 to m1.
      // document.getElementById("comments-list").insertAdjacentHTML('beforeend', `
      //   <tr>
      //     <td>${moodBlock}</td>
      //     <td><span class="tagContainer">${otherTags}</span></td>
      //     <td><span class="moodComment"> ${comment}</span></td>
      //   </tr>`)
    }
  }
}

function _printHTMLMoodComments(queryDates, day, entryNum) {
  // if an entry has a mood tag, grab its comment
  // sort them into a list, grouped by the same mood comment, in time order
  // print its moodnum+colour, its tag, and its comment into a list
  let dates = Object.keys(queryDates);
  let entry = queryDates[dates[day]].entries[entryNum];

  let moodComment = [];

  // if the entry has a comment or a mood tag
  if (entry.comment != " " || window.fm.mood.some((r) => entry.tags.includes(r))) {
    let comment = data.parseComments(entry.comment);
    let moodTag, energyTag, otherTags;
    let pop = "";
    let moodBlock = "";
    let energyBlock = "";

    entry.tags.forEach((tag) => {
      if (window.fm.mood.includes(tag)) {
        moodTag = makeMoodTag(entry, tag);
        moodBlock = `<span class="moodBlock" id="${moodTag[0]}">${moodTag[0]}</span>`;
      } else if (window.fm.energy.includes(tag)) {
        energyTag = makeMoodTag(entry, tag, "e");
        energyBlock = `<span class="energyBlock" id="${energyTag[0]}">${energyTag[0]}</span>`;
      }
    });

    otherTags = entry.tags.filter((tag) => !window.fm.mood.includes(tag));
    otherTags = otherTags.filter((tag) => !window.fm.energy.includes(tag));
    if (otherTags.length != 0) {
      otherTags.sort(tagOrder);
      otherTags.forEach((tag) => {
        pop += `<span class="tag ${tag}">${tag}</span> `;
      });
    }

    // here, add the entry printout into an array so i can sort them from m10 to m1.
    document.getElementById("comments-list").insertAdjacentHTML(
      "beforeend",
      `
      <tr>
        <td>${moodBlock}</td>
        <td>${energyBlock}</td>
        <td><span class="tagContainer">${pop}</span></td>
        <td><span class="moodComment"> ${comment}</span></td>
      </tr>`,
    );

    moodComment.push(moodTag);
    moodComment.push(entry.comment);
  }

  function tagOrder(tag1, tag2) {
    if ([tag1, tag2].some((tag) => window.fm.energy.includes(tag))) {
      return 1;
    }
  }
}

function makeMoodTag(entry, tag, _type = "m") {
  if (window.fm.mood.includes(tag) || window.fm.energy.includes(tag)) {
    let moodTag = tag;
    let mood = moodTag;
    mood = mood.replace("m", "");
    return [moodTag, mood];
  }
}

function makeQuerySummary(dates) {
  window.viewQuery.querySummary = {
    sumTotalMinsLogged: 0,
    categoryDurations: {},
    areaDurations: {},
  };

  // make a duration list for each day. then combine them all after.
  let mainSummaryListAllDays = [];
  for (let eachDay = 0; eachDay < dates.length; eachDay++) {
    if (dates[eachDay][1] != undefined) {
      mainSummaryListAllDays[eachDay] = { ...dates[eachDay][1].summary }; // [ {sit: 90}, {ttp: 120}, {jrnl: 30} ]
    } else {
      mainSummaryListAllDays[eachDay] = {}; // [ {sit: 90}, {ttp: 120}, {jrnl: 30} ]
    }
  }

  // combine the lists into a single one: mainSummaryListUnfiltered
  let mainSummaryListUnfiltered = {};
  for (let i = 0; i < mainSummaryListAllDays.length; i++) {
    let entries = Object.entries(mainSummaryListAllDays[i]);

    for (let [key, val] of entries) {
      if (!mainSummaryListUnfiltered[key]) {
        mainSummaryListUnfiltered[key] = val;
      } else {
        mainSummaryListUnfiltered[key] += Number([val]);
      }
    }
  }

  // filter out entries if they're part of `logObj.cycles`
  let mainSummaryList = { ...mainSummaryListUnfiltered };

  window.fm.cycles.forEach((tag) => {
    if (mainSummaryList[tag] != undefined) {
      delete mainSummaryList[tag];
    }
  });

  // filter out entries if they're part of window.fm.mood
  window.fm.mood.forEach((tag) => {
    if (window.fm.mood.includes(tag)) {
      delete mainSummaryList[tag];
    }
  });

  // rename the untagged as "untagged"
  if (mainSummaryList[""]) {
    mainSummaryList["untagged"] = mainSummaryList[""];
    delete mainSummaryList[""];
  }
  // for now, delete untagged also. maybe will use in the future...
  delete mainSummaryList["untagged"];

  let _listOfCorrectTagOrdering = makeListofCorrectTagOrdering(mainSummaryList);

  // make Ordered Summary List
  let orderedSummaryList = Object.entries(mainSummaryList).sort((item1, item2) => {
    return item1[1] < item2[1];
  });

  window.viewQuery.querySummary.mainSummaryList = mainSummaryList;
  window.viewQuery.querySummary.orderedSummaryList = orderedSummaryList;
  window.viewQuery.querySummary.categoryDurations = makeCategoryDurations();

  // console.info('❓ window.viewQuery.querySummary: ', window.viewQuery.querySummary)

  return mainSummaryList;
}

/**
  Returns an object with the hour/minute total duration of all the activities within a particular category group, eg. Coding, Self, etc.
*/
function makeCategoryDurations() {
  // [] make a list of which categories are featured in the list of tags

  // entries
  const entryCollection = [];
  Object.values(window.viewQuery.query).forEach((date) => {
    Object.values(date.entries).forEach((entry) => entryCollection.push(entry));
  });

  // loop through Categories
  Object.entries(window.fm.categories).forEach((category) => {
    const categoryName = category[0];
    const categoryTags = category[1];

    entryCollection.forEach((entry) => {
      // is this entry part of the category?
      const entryIsInCategory = categoryTags.some((categoryTag) =>
        entry.tags.includes(categoryTag.name) ? true : false,
      );

      // add entry duration to the category
      if (entryIsInCategory) {
        if (!window.viewQuery.querySummary.categoryDurations[categoryName]) {
          window.viewQuery.querySummary.categoryDurations[categoryName] = entry.duration;
        } else {
          window.viewQuery.querySummary.categoryDurations[categoryName] += entry.duration;
        }
      }
    });
  });

  // console.info(`window.fm.categoriesDurations:`, window.viewQuery.querySummary.categoryDurations)
  // console.info( window.fm.categoriesDurations )
  // delete window.fm.categoriesDurations.mood
  // delete window.fm.categoriesDurations.energy
  // delete window.fm.categoriesDurations.clarity

  return window.viewQuery.querySummary.categoryDurations;
}

function displayMoodGraph(dates) {
  makeMoodList(dates); // make a list of moods for each day in the query

  // print moodGraph
  for (let eachDay = 0; eachDay < dates.length; eachDay++) {
    let date = dates[eachDay][1];

    let moodArray = rhythm.getRhythmDataForDay(date, "mood");
    let energyArray = rhythm.getRhythmDataForDay(date, "energy");
    let clarityArray = rhythm.getRhythmDataForDay(date, "clarity");
    // console.log(moodArray)
    // console.log(energyArray)
    // console.log(clarityArray)

    let graphWidth = document.getElementById("graph-mood").offsetWidth; //960;

    if (time.getQueryTimeSpan() == "week") {
      graphWidth /= 7;
    }
    let graphHeight = 90;
    let moodSection = graphWidth / 3;
    let moodSection2 = moodSection * 2;

    if (time.getQueryTimeSpan() != "month") {
      document.getElementById("bars").insertAdjacentHTML(
        "beforeend",
        `

        <div class="mood${eachDay}" style="height: auto; position: relative;">

          <svg preserveAspectRatio="none" viewBox="0 0 ${graphWidth} ${graphHeight - 10}"
          style="border: solid var(--dark4); border-width: 0 1 0 0; min-height: 80px; height: ${graphHeight}; width: 100%; ">

            <defs>
              <linearGradient id="moodGradient" x1="50%" y1="100%" x2="50%" y2="0%" gradientUnits="userSpaceOnUse">
                <stop offset="0%"   stop-color="var(--mood1)" />
                <stop offset="30%"  stop-color="var(--mood3)" />
                <stop offset="50%"  stop-color="var(--mood5)" />
                <stop offset="70%"  stop-color="var(--mood7)" />
                <stop offset="100%" stop-color="var(--mood9)" />
              </linearGradient>
            </defs>

            <rect fill="#ccf5f554" width=${moodSection} height=${graphHeight} style="opacity: 0.1"  />
            <rect fill="#dceeeea3" x=${moodSection}  width=${moodSection} height=${graphHeight} style="opacity: 0.1"/>
            <rect fill="#151818ed" x=${moodSection2} width=${moodSection} height=${graphHeight} style="opacity: 0.1"/>

            ${svg.graph_grid(graphWidth, graphHeight, ui.dayLength, Object.keys(window.fm.mood).length)}

            <path
              type="clarity"
              d="${svg.createMoodLine(clarityArray, graphWidth, graphHeight)}"
              fill="none" stroke="#fff5" stroke-width="1" stroke-linecap="round"
            />
            <path
              type="energy"
              d="${svg.createMoodLine(energyArray, graphWidth, graphHeight)}"
              fill="none" stroke="var(--mood4)" stroke-width="1" stroke-linecap="round"
            />
            <path
              type="mood"
              d="${svg.createMoodLine(moodArray, graphWidth, graphHeight)}"
              fill="none" stroke="url('#moodGradient')" stroke-width="2" stroke-linecap="round"
            />

          </svg>

        </div>
      `,
      );
    } else {
      document.getElementById("bars").insertAdjacentHTML(
        "beforeend",
        `
        <div class="moodGraph mood${eachDay}">
          <bar id="m9"  class="off"></bar>
          <bar id="m8"  class="off"></bar>
          <bar id="m7"  class="off"></bar>
          <bar id="m6"  class="off"></bar>
          <bar id="m5"  class="off"></bar>
          <bar id="m4"  class="off"></bar>
          <bar id="m3"  class="off"></bar>
          <bar id="m2"  class="off"></bar>
          <bar id="m1"  class="off"></bar>
        </div>
        `,
      );

      // go through each moodList for each day, toggle the relevant moods on

      for (let x = 0; x < dates[eachDay][1].mood_simple.length; x++) {
        let mood = dates[eachDay][1].mood_simple[x]; // "m1", "m5", etc.
        document.querySelector(`.mood${eachDay} #${mood}`).setAttribute("class", "on");
      }
    }
  }

  // insert dates range display

  // make an html object with the range numbers
  let dateRangeHTML = '<div class="date-range">';

  if (time.getQueryTimeSpan() == "day") {
    // hour-range for timespan==day
    for (let hour = ui.dayStartTime; hour < ui.dayLength + ui.dayStartTime; hour++) {
      let printHour = hour;
      if (hour >= ui.dayLength) {
        printHour = hour - ui.dayLength;
      }
      dateRangeHTML += `<span class="date">${printHour}</span>`;
    }
  } else if (time.getQueryTimeSpan() == "year") {
    for (let month = 0; month < 12; month++) {
      dateRangeHTML += `
        <span class="date-group">
          <span class="month">${ui.monthNamesShort[month]}</span>
        </span>`;
    }
  } else {
    // date-range for !timespan==day
    for (let date = 0; date < dates.length; date++) {
      dateRangeHTML += `<span class="date"> ${new Date(dates[date][0]).getDate()}</span>`;
    }
  }

  dateRangeHTML += `</div>`;

  document.getElementById("graph-mood").insertAdjacentHTML("afterbegin", dateRangeHTML);
}

function makeMoodList(dates) {
  // Mood lists
  // make mood list out of the summary. remove moods from mainSummaryList.

  for (let eachDay = 0; eachDay < dates.length; eachDay++) {
    dates[eachDay][1].mood_simple = [];

    if (dates[eachDay][1].summary) {
      // if the day isn't blank
      let moodTag = Object.keys(dates[eachDay][1].summary);
      moodTag.forEach((tag) => {
        if (window.fm.mood.includes(tag)) {
          delete dates[eachDay][1].summary["tag"];
          dates[eachDay][1].mood_simple.push(tag);
        }
      });
    }

    // console.info(`💙 Moodlist:`)
    // console.log(dates[eachDay][1].mood)
  }
}

function makeListofCorrectTagOrdering(mainSummaryList) {
  // Make a comparison list, by looping through logObj.statsList,
  let listOfCorrectOrdering = [];
  let listOfTagsPerCategory = Object.values(window.fm.categories);

  // add all tags from the category list into listOfCorrectOrdering
  for (let tagList = 0; tagList < listOfTagsPerCategory.length; tagList++) {
    for (let tag = 0; tag < listOfTagsPerCategory[tagList].length; tag++) {
      let item = listOfTagsPerCategory[tagList][tag];
      if (!listOfCorrectOrdering.includes(item)) {
        listOfCorrectOrdering.push(item);
      }
    }
  }
  // add all tags from the mainSummaryList list into listOfCorrectOrdering
  for (let tagList = 0; tagList < listOfTagsPerCategory.length; tagList++) {
    for (let tagDurationPair = 0; tagDurationPair < Object.entries(mainSummaryList).length; tagDurationPair++) {
      let item = Object.entries(mainSummaryList)[tagDurationPair][0];
      if (!listOfCorrectOrdering.includes(item)) {
        listOfCorrectOrdering.push(item);
      }
    }
  }
  return listOfCorrectOrdering;
}

function _displayMainSummaryList(_dates) {
  // Print item into the Main Summary List
  // return
  // this code breaks if the entry has less than 1 min duration
  // the document.querySelector(`#stats li.${category}`) stops working

  for (let tdPair = 0; tdPair < window.viewQuery.querySummary.orderedSummaryList.length; tdPair++) {
    let tag = window.viewQuery.querySummary.orderedSummaryList[tdPair][0];
    let duration = window.viewQuery.querySummary.orderedSummaryList[tdPair][1];

    // count how many blocks per item
    let blocks = "";
    for (let hour = 0; hour < Math.floor(duration / 60); hour++) {
      // print a full block per hour
      blocks += `<o class="block "></o>`;
    }
    // print a partial block based on minutes
    blocks += `<o class="block min"><i style="width: ${Math.round((Math.floor(duration % 60) / 60) * 100)}%;"></i></o> `;

    let _category;
    let durationHM = time.minsToHM(duration);

    Object.entries(window.fm.categories).forEach((category) => {
      if (category[1].includes(`${tag}`)) {
        category = category[0];
        document.querySelector(`#stats li.${category}`).insertAdjacentHTML(
          "beforeend",
          `
          <li tag>
            <span class="tag ${tag}"><span class="tag-label">${tag}</span></span>
            <span class="duration">
              ${durationHM}
            </span>
            <span class="blocks">${blocks}</span>
          </li>
        `,
        );
      }
    });
  }
}

function displayAreaSummary() {
  // loop through areas
  Object.entries(window.fm.areas).forEach((areas) => {
    let area = areas[0].charAt(0).toUpperCase() + areas[0].slice(1);

    // if (window.viewQuery.querySummary.areaDurations[area] != undefined) {

    // }
    // console.log(window.viewQuery.querySummary.areaDurations)

    // print area container
    document.getElementById("areas").insertAdjacentHTML("beforeend", `<div class="area" id="${area}"></div>`);

    // console.log(areas)
    let areaSet = areas[1];
    areaSet.forEach((category) => {
      let categoryDuration = window.viewQuery.querySummary.categoryDurations[category];

      // calculate area durations
      if (window.viewQuery.querySummary.areaDurations[area] == undefined) {
        window.viewQuery.querySummary.areaDurations[area] = categoryDuration;
      } else if (categoryDuration != undefined) {
        window.viewQuery.querySummary.areaDurations[area] += categoryDuration;
      }

      if (window.viewQuery.querySummary.categoryDurations[category]) {
        displayCategorySummary(area, category);
      }
    });

    let link = "#";
    if (area == "Projects") {
      link = "obsidian://open?vault=MainVault&file=Plan/@Projects";
    }
    if (area == "Practice") {
      link = "obsidian://open?vault=MainVault&file=Plan/@Areas";
    }

    // print area header
    document
      .querySelector(`#areas .area#${area}`)
      .insertAdjacentHTML("afterbegin", `<h3><a href="${link}">${area}</a></h3>`);

    // if there is a duration for this [area]
    if (
      Object.keys(window.viewQuery.querySummary.areaDurations).includes(area) &&
      window.viewQuery.querySummary.areaDurations[area] != undefined
    ) {
      // print area duration
      document
        .querySelector(`#areas .area#${area} h3`)
        .insertAdjacentHTML(
          "beforeend",
          `<span class="totalDuration">${time.minsToHM(window.viewQuery.querySummary.areaDurations[area])}</span>`,
        );
    }
  });
}

function displayCategorySummary(area, category) {
  // console.log(area)
  // console.log(category)
  // if (category == 'misc') {return}

  let totalDuration = time.minsToHM(window.viewQuery.querySummary.categoryDurations[category]);

  // print category container
  document.querySelector(`#areas .area#${area} `).insertAdjacentHTML(
    "beforeend",
    `
    <div class="categorySummary category-${category}">
      <div class="entries"></div>
    </div>
    `,
  );

  // print category name
  document
    .querySelector(`#areas .area#${area} .categorySummary.category-${category}`)
    .insertAdjacentHTML("afterbegin", `<h4>${category} <span class="totalDuration">${totalDuration}</span></h4>`);

  // populate with category entries
  Object.values(window.viewQuery.query).map((day) => {
    if (day.entries.length > 0) {
      // get each entry for each day
      day.entries.forEach((entry) => {
        // get the tags for each entry
        entry.tags.map((tag) => {
          // console.log(tag)

          Object.values(window.fm.categories[category]).forEach((tagObj) => {
            // if the tag is part of this category, then...
            if (tagObj.name === tag) {
              // console.log(entry.duration)

              // prepare to print entry tag label
              let durationDisplay = `<span class="goal-practiced">${time.minsToHM(entry.duration)}</span>`;
              let labelDuration = `<span class="label-duration">${durationDisplay}</span>`;
              let duration = entry.duration;
              let width = `calc( ${duration}px * var(--summaryEntryWidth) )`;
              let tagWrap = document.querySelector(
                `#areas .categorySummary.category-${category} .entries div.tag-wrap[data-tag="${tag}"]`,
              );

              // if there is already a tagWrap with this tag, then add a tag inside.
              // Else, create the tag-wrap first.

              if (tagWrap) {
                tagWrap.insertAdjacentHTML(
                  "beforeend",
                  `<div class="tag summary-entry" data-tag="${tag}" style="width: ${width}; min-width: ${width};">&nbsp;</div>`,
                );

                // update the durationDisplay if there's more than one entry
                window.viewQuery.querySummary.orderedSummaryList.forEach((item) => {
                  // console.log('item: ', item)
                  if (item[0] === tag) {
                    let newTotal = item[1];
                    let difference = "";

                    durationDisplay = `<span class="difference">${difference}</span> <span class="goal-practiced">${time.minsToHM(newTotal)}</span>`;
                    document.querySelector(
                      `#areas .categorySummary.category-${category} .entries div[data-tag="${tag}"] .label-duration`,
                    ).innerHTML = durationDisplay;
                  }
                });
              } else {
                // if this tag is included in the window.fm.goals object,
                // then check it's duration, and add that as the width of the tag-wrap
                let goalDuration_px = "";
                if (Object.keys(window.fm.goals).includes(tag)) {
                  goalDuration_px = `style="min-width: ${window.fm.goals[tag].target_day * CSS.summaryEntryWidth + "px"}"`;
                }

                document.querySelector(`#areas .categorySummary.category-${category} .entries`).insertAdjacentHTML(
                  "beforeend",

                  `<div class="entry-wrap" data-tag="${tag}">

                      <div class="tag-label">
                        <a href="#${tag}" onclick="displayTagOverlay('${tag}')">${tag}</a>
                      </div>

                      <div class="tag-wrap ${tag}" data-tag="${tag}" style="width: ${goalDuration_px}">
                        <div class="tag summary-entry" data-tag="${tag}" data-duration="${entry.duration}" style="width: ${width}; min-width: ${width}"></div>
                      </div>

                    ${labelDuration}

                  </div>
                  `,
                );
              }
            }
          }); // end - if (window.fm.categories[category].includes(tag))
        }); // end - entry.tags.map
      }); // end - day.entries.forEach
    } // end - if (day.entries.length >=1)
  }); // end - Object.values(window.viewQuery.query).map
}

function displaySummary(queryDates = queryLog()) {
  // console.info('🔅 Summary ')
  clearSummary(); // remove all entries to start fresh

  let _dates = Object.entries({ ...queryDates });

  displayAreaSummary(); // main areas: Projects, Practice, Other, Self

  // displayCategoriesRatioBar()

  // ========= SUMMARY STATS BOX =========

  function sumTotalMinsLogged() {
    for (let d = 0; d < window.viewQuery.querySummary.orderedSummaryList.length; d++) {
      let duration = window.viewQuery.querySummary.orderedSummaryList[d][1];
      window.viewQuery.querySummary.sumTotalMinsLogged += +duration;
    }
    return time.splitminsToHM(window.viewQuery.querySummary.sumTotalMinsLogged);
  }

  // display TotalLogged
  window.HTML.summaryStats.insertAdjacentHTML(
    "beforeend",
    `<li class="total">Total Logged: ${sumTotalMinsLogged()}</li>`,
  );

  // display Tracked Ratio
  // displayTrackedRatio( dates )

  // displayMainSummaryList( dates )
}

function displayYearSummary() {
  document.getElementById("year-summary").innerHTML = "";
  document.getElementById("year-summary").insertAdjacentHTML(
    "beforeend",
    `
    <span class="data"></span>
    <o><prog></prog></o>
    `,
  );

  // from http://stackoverflow.com/questions/8619879/ddg#8619946
  let now = new Date();
  let start = new Date(now.getFullYear(), 0, 0);
  let diff = now - start + (start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000;
  let oneDay = 1000 * 60 * 60 * 24;
  let dayOfYear = Math.floor(diff / oneDay);

  let thisWeek = time.compareTwoDatesExcludingTime(window.viewQuery.today)[1];
  let finalWeek = 52;
  let yearPercentCompleted = Math.round((thisWeek / finalWeek) * 100);

  let daysLeft = 365 - dayOfYear;
  let weeksLeft = finalWeek - thisWeek;
  let monthsLeft = 12 - (window.viewQuery.today.getMonth() + 1);
  let yearLeft = 100 - yearPercentCompleted;

  document.querySelector("#year-summary .data").innerHTML =
    `Remaining: ${daysLeft} Days / ${weeksLeft} Weeks / ${monthsLeft} Months / ${yearLeft}% of the Year`;

  document.querySelector("#year-summary o").innerHTML = `<prog style="width: ${yearPercentCompleted}%"></prog>`;

  console.log("❓ window.viewQuery", window.viewQuery);
}

// ========= Displaying the Daily Graph ========= ========= ========

function clearGraph() {
  window.HTML.graphContainer.innerHTML = `
    <div id="graph-date">
    </div>

    <div id="graph-timebar">
      <ul></ul>
    </div>

    <div id="graph-entries">
    </div>
  `;
  // window.HTML.graph.innerHTML = ""
  // window.HTML.graphDate.innerHTML = ""
  // window.HTML.graphTimeBar.innerHTML = ""
  window.HTML.graphMood.innerHTML = `<h3>Mood</h3><div id="bars"></div>`;
  document.getElementById("comments-list").innerHTML = "";
}

function displayQueryDate(date) {
  document.getElementById("query-date").innerHTML = time.dateFormatterWDMY(date);
}

function _PrintEntryPill(_entryData) {
  entryData = {
    entryStartPosY: undefined,
    entryStartPosX: undefined,
    entryHeight: undefined,
    entryWidth: undefined,
    entryLine: undefined,
    tagList: undefined,
    spanEntryStart: undefined,
    tagSpan: undefined,
    spanDuration: undefined,
    spanEntryComment: undefined,
    entry: undefined,
    day: undefined,
  };
}

function printHTMLGraphEntry(queryDates, day, entryNum) {
  let dates = Object.keys(queryDates);
  let entry = queryDates[dates[day]].entries[entryNum];
  if (!entry) {
    console.warn("KTT printHTMLGraphEntry()", entry);
  }

  let entryData = {
    entryStartPosY: undefined,
    entryStartPosX: undefined,
    entryHeight: undefined,
    entryWidth: undefined,
    entryLine: "",
    tagList: undefined,
    spanEntryStart: "",
    spanEntryEnd: "",
    tagSpan: undefined,
    spanDuration: undefined,
    spanEntryComment: undefined,
    entry: entry,
    day: day,
    type: "tag",
  };

  // DOM elements inside the entry:
  // =========

  entryData = formatEntryPillElements(entryData);
  entryData = calculateEntryPillDimensions(entryData);
  entryData.entry.tags = filterRhythmTags(entryData.entry);

  printEntryPill(entryData);
  printEntryPillExtended(entryData);
}

function formatEntryPillElements(entryData) {
  // Entry start-time ("span.entry-start")
  entryData.spanEntryStart = `<span class="entry-start">${entryData.entry.start}</span>`;

  // Entry end-time
  if (entryData.type.includes("future")) {
    console.log("=========  ========= =========yes future");
    entryData.spanEntryEnd = `<span class="entry-start entry-end">${entryData.entry.end}</span>`;
  }

  // entry.tags
  entryData.tagSpan = [];

  if (!entryData.entry.tags) {
    entryData.tagSpan = "";
  } else {
    entryData.tagList = tags.stripTags(entryData.entry.tags);

    // Cut out Rhythm tags: Mood or Energy
    for (let tag = 0; tag < entryData.tagList.length; tag++) {
      if (window.fm.mood.includes(entryData.tagList[tag])) {
        entryData.tagList.splice(tag, 1);
        if (entryData.tagList.length == 0) {
          return;
        }
      }
      if (window.fm.energy.includes(entryData.tagList[tag])) {
        entryData.tagList.splice(tag, 1);
        if (entryData.tagList.length == 0) {
          return;
        }
      }
      if (window.fm.clarity.includes(entryData.tagList[tag])) {
        entryData.tagList.splice(tag, 1);
        if (entryData.tagList.length == 0) {
          return;
        }
      }
    }

    // prep tags HTML
    for (let t = 0; t < entryData.tagList.length; t++) {
      entryData.tagSpan.push(`<span class="tag-label">${entryData.tagList[t]}</span>`);
    }

    // remove the ","" separator, leaving a space so they don't stick.
    entryData.tagSpan = entryData.tagSpan.join(" ");
    entryData.tagList = entryData.tagList.join(" ");
  }

  // entry.duration
  entryData.spanDuration = "";
  if (entryData.entry.duration != 0) {
    entryData.spanDuration = `<span class="entry-duration">${time.splitminsToHM(entryData.entry.duration)}</span>`;
  }

  // entry.comment
  entryData.spanEntryComment = "";

  if (entryData.entry.comment || (entryData.entry.comment != " " && entryData.entry.comment != "")) {
    entryData.spanEntryComment = `<span class="entry-comment">${data.parseComments(entryData.entry.comment)}</span>`;
  }
  return entryData;
}

function calculateEntryPillDimensions(entryData) {
  // console.log('entryData', entryData)

  // calculate widths and positions
  // ========= =========
  // get start and end times
  let startPosH = entryData.entry.start.slice(0, 2);
  let startPosM = entryData.entry.start.slice(3);

  // calculate start position
  // shift an entry down if its from the prior day
  if (startPosH < ui.dayStartTime) {
    startPosH = +startPosH + ui.dayLength;
  }

  entryData.entryStartPosX = Math.round((startPosM * 100) / 60);
  entryData.entryStartPosY = Math.round(startPosH * CSS.graphHourHeight - ui.dayStartTime * CSS.graphHourHeight);

  entryData.entryHeight = CSS.graphHourHeight - CSS.entryBorderWidth * 2 + 1;
  entryData.entryWidth = Math.floor((entryData.entry.duration * 100) / 60);

  // limit to graph width.
  if (entryData.entryStartPosX + entryData.entryWidth > ui.entryMaxWidth) {
    entryData.entryWidth -= entryData.entryStartPosX + entryData.entryWidth - 100;
  }

  entryData.entryWidth = `${entryData.entryWidth}%`;
  if (entryData.entry.duration == undefined) {
    entryData.entry.duration = "";
  } // the last entry of the day

  // if its a rhythm only, set to min-width
  if (
    window.fm.cycles.some((tag) => entryData.tagList.includes(tag.name)) ||
    window.fm.tags.every((tag) => !entryData.tagList.includes(tag.name))
  ) {
    entryData.entryWidth = "min-content";
  }

  return entryData;
}

function printEntryPill(entryData) {
  const rhythm = table.HTML_rhythm_widget(entryData.entry).outerHTML || "";

  const pill = document.createElement("li");
  pill.classList.add(entryData.type);
  pill.setAttribute("line", entryData.entryLine);
  pill.dataset.tag = String(entryData.tagList);
  pill.style = `position: absolute;
    top: ${entryData.entryStartPosY}px;
    left: ${entryData.entryStartPosX}%;
    height: ${entryData.entryHeight}px;
    width: ${entryData.entryWidth}"`;
  pill.innerHTML = `
    <span class='tag-label'>${entryData.entry.tags}</span>
    ${entryData.spanEntryStart}
    ${entryData.spanDuration}
    ${entryData.spanEntryComment}
    ${rhythm}
    ${entryData.spanEntryEnd}`;

  const tooltip = tippyHandler({
    content: editEntryModalTooltip(entryData.entry),
    parent: pill,
  });

  document.getElementById(`u${entryData.day}`).insertAdjacentElement("beforeend", tooltip);
}

function printEntryPillExtended(entryData) {
  // print extended lines if entry goes over max width
  let minute = CSS.graphContainerWidth / 60;
  let finalStartPosX = entryData.entry.duration * minute + entryData.entryStartPosX;

  if (finalStartPosX > ui.entryMaxWidth) {
    entryData.spanEntryStart = "";
    entryData.tagSpan = "";
    entryData.spanDuration = "";
    entryData.spanEntryComment = "";
    entryData.entryLine = "new";

    let _firstLineWidth = CSS.graphContainerWidth - entryData.entryStartPosX;
    let nextLineWidth = (entryData.entry.duration * 100) / 60 - (100 - entryData.entryStartPosX);

    let numberOfNewLines = Math.floor((entryData.entry.duration - 1 + entryData.entryStartPosX / (100 / 60)) / 60);
    // -1 to prevent a new line happening if an entry ends at the end of a line

    for (let num = 0; num < numberOfNewLines; num++) {
      if (num != numberOfNewLines - 1) {
        entryData.entryWidth = 100;
      } else {
        entryData.entryWidth = Math.abs(((numberOfNewLines - 1) * 100) / 60 - nextLineWidth);
        entryData.entryWidth = Math.floor(Math.abs(entryData.entryWidth - (numberOfNewLines - 1) * 100));
      }
      entryData.entryWidth = `${entryData.entryWidth}%`;
      entryData.entryStartPosY = +entryData.entryStartPosY + +CSS.graphHourHeight;
      entryData.entryStartPosX = "";

      printEntryPill(entryData);
    }
  }
}
function printEntryPill2(entryData, currentLine = 0) {
  const rhythm = table.HTML_rhythm_widget(entryData.entry).outerHTML || "";
  document.getElementById(`u${entryData.day}`).insertAdjacentHTML(
    "beforeend",
    `
    <li
      style="
        position: absolute;
        top: ${entryData.entryStartPosY}px;
        left: ${entryData.entryStartPosX}%;
        height: ${entryData.entryHeight}px;
        width: ${entryData.entryWidth}"
      class="${entryData.type}"
      line="${entryData.entryLine}"
      data-tag="${entryData.tagList}">
      ${entryData.tagSpan}
      ${entryData.spanEntryStart}
      ${entryData.spanDuration}
      ${entryData.spanEntryComment}
      ${rhythm}
      ${entryData.spanEntryEnd}
    </li>`,
  );

  let minute = CSS.graphContainerWidth / 60;
  let finalStartPosX = entryData.entry.duration * minute + entryData.entryStartPosX;

  let numberOfNewLines = 0;

  if (finalStartPosX > ui.entryMaxWidth) {
    let lineWidth = CSS.graphContainerWidth / minute;

    if (currentLine === 0) {
      let initialOffset = (entryData.entryStartPosX / 100) * lineWidth;
      let nextLineDuration = entryData.entry.duration - (lineWidth - initialOffset);

      numberOfNewLines = Math.ceil(nextLineDuration / lineWidth) + 1;
      entryData.entry.duration = lineWidth - initialOffset;
    } else {
      let nextLineDuration = entryData.entry.duration;
      numberOfNewLines = Math.ceil(nextLineDuration / lineWidth);

      entryData.entry.duration = Math.min(lineWidth, nextLineDuration);
    }

    entryData.spanEntryStart = "";
    entryData.tagSpan = "";
    entryData.spanDuration = "";
    entryData.spanEntryComment = "";
    entryData.entryLine = "new";
    entryData.entryStartPosY = +entryData.entryStartPosY + +CSS.graphHourHeight;
    entryData.entryStartPosX = "0%";

    if (currentLine !== numberOfNewLines - 1) {
      entryData.entryWidth = "100%";
    } else {
      entryData.entryWidth = `${((entryData.entry.duration * minute) / CSS.graphContainerWidth) * 100}%`;
    }

    printEntryPill2(entryData, currentLine + 1);
  }
}

// ========= ========= ========= ========= ========= ========= ========= =========

// Get Info
function _getDayStartTime(_date) {
  // what is the start time of the first entry after the rise entry?
}

// ========= HTML Stuff ========= ========= ========= ========= =========

function dateShifter(dayShift = 0, weekShift = 0, monthShift = 0, yearShift = 0) {
  let finalDates = [];

  toggleEntryTime(true);
  toggleEntryComment(true);
  toggleEntryTag(true);
  toggleEntryDuration(true);

  // Today
  if (dayShift == 0 && weekShift == 0 && monthShift == 0 && yearShift == 0) {
    document.querySelector("body").setAttribute("timeSpan", "day");

    window.viewQuery.queryDate = new Date(window.viewQuery.today);

    // show the previous day if we are before 5am the next day
    const now = new Date();

    if (now.getTime() < now.setHours(ui.dayStartTime - 1)) {
      let newToday = new Date(window.viewQuery.today);
      window.viewQuery.queryDate = new Date(newToday.setDate(newToday.getDate() - 1));

      finalDates = [window.viewQuery.queryDate];
      return finalDates;
    }
  }

  // DayShift
  // calculate what the output date should be
  if (dayShift) {
    document.querySelector("body").setAttribute("timeSpan", "day");

    window.viewQuery.queryDate.setDate(window.viewQuery.queryDate.getDate() + dayShift);
    finalDates = [window.viewQuery.queryDate];
    return finalDates;
  }

  // WeekShift
  if (weekShift) {
    document.querySelector("body").setAttribute("timeSpan", "week");
    let currentViewDate = window.viewQuery.queryDate.getDay();

    // the current day number (0-6) minus 1 is how many days to go back to grab the Monday
    let shiftAmount = (currentViewDate - 1) * -weekShift;
    if (shiftAmount == -1) {
      shiftAmount = 6;
    }
    if (shiftAmount == 0) {
      shiftAmount = 7;
    }
    shiftAmount *= weekShift;

    // "This Week" button
    if (weekShift == 9) {
      // calculate the difference between the queryDate that we're seeing, and the last monday
      // from today. that is the shift amount
    }

    for (let x = 0; x < 7; x++) {
      // calculate what the output date should be
      window.viewQuery.queryDate.setDate(window.viewQuery.queryDate.getDate() - -shiftAmount);
      shiftAmount = Math.abs(weekShift);
      finalDates.push(new Date(window.viewQuery.queryDate));
    }

    window.viewQuery.queryDate.setDate(window.viewQuery.queryDate.getDate() + 6 * -Math.abs(weekShift));

    toggleEntryTime(false);
    toggleEntryComment(false);
    toggleEntryTag(true);
    toggleEntryDuration(false);
    toggleGraphBorders(true);

    return finalDates;
  }

  // MonthShift
  if (monthShift) {
    document.querySelector("body").setAttribute("timeSpan", "month");
    toggleEntryTime(false);
    toggleEntryComment(false);
    toggleEntryTag(false);
    toggleEntryDuration(false);
    toggleGraphBorders(true);

    let shift = monthShift;
    let d = window.viewQuery.queryDate;
    // console.log(d)
    let firstDay = new Date(d.getFullYear(), d.getMonth() + shift);
    // console.log(firstDay)
    let lastDay = new Date(d.getFullYear(), d.getMonth() + shift + 1, 0);
    let numberOfDays = lastDay.getDate() - firstDay.getDate() + 1;
    // console.log(`monthShift: ${monthShift}`)
    // console.log(`first: ${firstDay}`)
    // console.log(`last:  ${lastDay .getDate()}`)
    // console.log(`month: ${firstDay.getMonth()}`)
    // console.log(`numberofDays: ${numberOfDays}`)

    window.viewQuery.queryDate.setFullYear(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate());
    finalDates.push(new Date(window.viewQuery.queryDate)); // the first date (0), before looping

    for (let x = 0; x < numberOfDays - 1; x++) {
      let _d = new Date(firstDay.getFullYear(), firstDay.getMonth(), x);
      window.viewQuery.queryDate.setDate(window.viewQuery.queryDate.getDate() + 1);
      finalDates.push(new Date(window.viewQuery.queryDate));
    }

    // console.log(window.viewQuery.queryDate)
    // console.log(finalDates)

    return finalDates;
  }

  // YearShift
  if (yearShift) {
    document.querySelector("body").setAttribute("timeSpan", "year");
    toggleEntryTime(false);
    toggleEntryComment(false);
    toggleEntryTag(false);
    toggleEntryDuration(false);
    toggleGraphBorders(false);

    let _shift = yearShift;
    let d = window.viewQuery.queryDate;
    let firstDay = new Date(d.getFullYear(), 0, 1);
    let _lastDay = new Date(d.getFullYear(), 11, 31);
    let numberOfDays = 365;
    // console.log(`yearshift: ${yearShift}`)
    // console.log(`first: ${firstDay.getDate()}`)
    // console.log(`last:  ${lastDay .getDate()}`)
    // console.log(`numberofDays: ${numberOfDays}`)

    window.viewQuery.queryDate.setFullYear(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate());
    finalDates.push(new Date(window.viewQuery.queryDate)); // the first date (0), before looping

    for (let x = 0; x < numberOfDays - 1; x++) {
      let _d = new Date(firstDay.getFullYear(), firstDay.getMonth(), x);
      window.viewQuery.queryDate.setDate(window.viewQuery.queryDate.getDate() + 1);
      finalDates.push(new Date(window.viewQuery.queryDate));
    }

    // console.log(window.viewQuery.queryDate)
    // console.log(finalDates)

    return finalDates;
  }
}

// ========= UI Preferences ========= ========= ========
// function toggleBox() {
//   ui.horizontalBlocks = !ui.horizontalBlocks;
//   displayLog()
// }

function toggleEntryTime(bool) {
  // console.log(`toggleEntryTime: ${bool}`)
  if (bool == undefined) {
    // console.log('blank')
    ui.entryStartTime = !ui.entryStartTime;
    // console.log(ui.entryStartTime)
  } else {
    // console.log('toggl')
    ui.entryStartTime = bool;
    // console.log('uistart is nowwwwww:')
    // console.log(bool)
  }

  if (bool == true || ui.entryStartTime == true) {
    // console.log(`if: ${bool}`)
    // console.log(ui.entryStartTime)

    // if (window.HTML.CSS.cssRules.length != 0) {
    document.querySelector(":root").style.setProperty("--entry-start", "block");
    // }
  } else if (bool == false || ui.entryStartTime == false) {
    document.querySelector(":root").style.setProperty("--entry-start", "none");
  }
}

function toggleEntryComment(bool) {
  if (bool != undefined) {
    ui.entryComment = bool;
  } else {
    ui.entryComment = !ui.entryComment;
  }

  if (bool == true) {
    document.querySelector(":root").style.setProperty("--entry-comment", "block");
  } else if (bool == false) {
    document.querySelector(":root").style.setProperty("--entry-comment", "none");
  }
}

function toggleEntryTag(bool) {
  if (bool != undefined) {
    ui.entryTagLabel = bool;
  } else {
    ui.entryTagLabel = !ui.entryTagLabel;
  }

  if (bool == true) {
    document.querySelector(":root").style.setProperty("--tagLabel", "block");
  } else if (bool == false) {
    document.querySelector(":root").style.setProperty("--tagLabel", "none");
  }
}

function toggleEntryDuration(bool) {
  if (bool != undefined) {
    ui.entryDuration = bool;
  } else {
    ui.entryDuration = !ui.entryDuration;
  }
  if (bool == true) {
    document.querySelector(":root").style.setProperty("--entry-duration", "block");
  } else if (bool == false) {
    document.querySelector(":root").style.setProperty("--entry-duration", "none");
  }
}

function toggleGraphBorders(bool) {
  if (bool != undefined) {
    ui.graphBorders = bool;
  } else {
    ui.graphBorders = !ui.graphBorders;
  }

  if (bool == true) {
    document.querySelector(":root").style.setProperty("--entry-border-width", "0 1px 0 0");
  } else if (bool == false) {
    document.querySelector(":root").style.setProperty("--entry-border-width", "0");
  }
}

// ========= Keyboard Controls ========= ========= =========

document.addEventListener("keyup", function (event) {
  // event.preventDefault()
  const activeElement = document.activeElement;
  const isFormField = activeElement.matches('input, textarea, [contenteditable="true"]');
  if (isFormField) {
    return;
  }

  if (event.key.includes("Arrow") && (event.shiftKey || event.altKey || event.ctrlKey)) {
    window.closeOverlay();
  }

  // modifiers: event.ctrlKey|shiftKey|altKey
  if (event.key == "ArrowLeft" && event.shiftKey) {
    shiftLastWeek();
    return;
  }
  if (event.key == "ArrowRight" && event.shiftKey) {
    shiftNextWeek();
    return;
  }

  if (event.key == "ArrowLeft" && event.altKey) {
    shiftLastMonth();
    return;
  }
  if (event.key == "ArrowRight" && event.altKey) {
    shiftNextMonth();
    return;
  }

  if (event.key == "ArrowLeft" && event.ctrlKey) {
    shiftLastYear();
    return;
  }
  if (event.key == "ArrowRight" && event.ctrlKey) {
    shiftNextYear();
    return;
  }

  switch (event.key) {
    case "t": {
      shiftToday();
      break;
    }
    case "ArrowLeft": {
      shiftYesterday();
      break;
    }
    case "ArrowRight": {
      shiftTomorrow();
      break;
    }
  }
});

document.getElementById("todayButton")?.addEventListener("click", shiftToday);
document.getElementById("yesterdayButton")?.addEventListener("click", shiftYesterday);
document.getElementById("tomorrowButton")?.addEventListener("click", shiftTomorrow);
document.getElementById("lastWeekButton")?.addEventListener("click", shiftLastWeek);
document.getElementById("nextWeekButton")?.addEventListener("click", shiftNextWeek);
document.getElementById("lastMonthButton")?.addEventListener("click", shiftLastMonth);
document.getElementById("nextMonthButton")?.addEventListener("click", shiftNextMonth);
document.getElementById("lastQuarterButton")?.addEventListener("click", shiftLastQuarter);
document.getElementById("nextQuarterButton")?.addEventListener("click", shiftNextQuarter);
document.getElementById("lastYearButton")?.addEventListener("click", shiftLastYear);
document.getElementById("nextYearButton")?.addEventListener("click", shiftNextYear);
document.getElementById("allLogButton")?.addEventListener("click", shiftAllLog);

// ========= Log Shift Functions ========= ========= ========

function shiftToday() {
  displayLog(queryLog(dateShifter()));
}
function shiftYesterday() {
  displayLog(queryLog(dateShifter(-1)));
}
function shiftTomorrow() {
  displayLog(queryLog(dateShifter(+1)));
}
function shiftLastWeek() {
  displayLog(queryLog(dateShifter(0, -1)));
}
function shiftNextWeek() {
  displayLog(queryLog(dateShifter(0, +1)));
}
function shiftLastMonth() {
  displayLog(queryLog(dateShifter(0, 0, -1)));
}
function shiftNextMonth() {
  displayLog(queryLog(dateShifter(0, 0, +1)));
}
function shiftLastQuarter() {
  displayLog(queryLog(dateShifter(0, 0, -3)));
}
function shiftNextQuarter() {
  displayLog(queryLog(dateShifter(0, 0, +3)));
}
function shiftLastYear() {
  displayLog(queryLog(dateShifter(0, 0, 0, -1)));
}
function shiftNextYear() {
  displayLog(queryLog(dateShifter(0, 0, 0, +1)));
}
function shiftAllLog() {
  displayLog(queryLog(dateShifter(0, 0, 0, +1)));
}

export { dateShifter };

// ========= Export ========= ========= ========
export { displayLog, queryLog };
